import React, { useRef } from "react";
import Modal from "../Modal";
import CompanyTree from ".";
import { useTranslation } from "../../langs/useTranslation";
import { toast } from "@/helpers/toast"

export default function CompanyTreeModal({
  open,
  companyId,
  excludeKeys,
  checkable,
  multiple,
  footer,
  onSelect,
  onClose,
  onConfirm,
  useParamId
}) {
  const tree = useRef(null);
  const { t } = useTranslation();

  const handleConfirm = () => {
    if (tree.current.getCheckedKeys().length === 0) {
      return toast.warning(t({ defaultMessage: "不可全部取消勾选" }));
    }
    onConfirm?.(
      tree.current.getCheckedKeys(),
      tree.current.getExcludeKeys(),
      tree.current.getAllKeys()
    );
    onClose?.();
  };

  return (
    <Modal
      onClose={onClose}
      onConfirm={handleConfirm}
      closeable
      open={open}
      width={576}
      title={t({ defaultMessage: "公司数据权限配置" })}
      footer={footer}
    >
      <CompanyTree
        checkable={checkable}
        multiple={multiple}
        excludeKeys={excludeKeys}
        companyId={companyId}
        useParamId
        onSelect={onSelect}
        ref={tree}
      />
    </Modal>
  );
}
